var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-title",style:({paddingTop: _vm.paddingTop + 'px', height: _vm.paddingTop + 54 +'px'})},[_c('span',{staticClass:"title"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }